import styled from 'styled-components';
import {layout} from '../../../../../package.json';

export const CreateClient = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0 2%;
  form{
    width: 100%;
  }
  > span{
    font-weight: 500;
    margin: 50px 0;
  }
`;

export const ColButton = styled.div`
  width: 100%;
  max-width: 400px;
  min-width: 70px;
  margin: 0 auto;
  margin-top: 30px;
`;

export const ColInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin: 0 auto;
  margin-bottom: 15px;
  width: 100%;
  max-width: 1000px;

  > div + div {
    margin-left: 1rem;
  }

  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
    > div + div {
    margin-left: 0rem;
    margin-top: 1rem;
  }
  }
`;

export const ContentButtonCancelProcess = styled.div`
width: 100%;
margin: 25px 0;
padding: 0 2%;
> div {
  margin-left: auto;
}
`

export const ContentCreateAddress = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  form{
    width: 100%;
  }
  > span{
    font-weight: 500;
    margin: 50px 0;
  }
`;